module.exports = __webpack_public_path__ + "img/22.48c6ec6d.png";